<template>
    <KServiceCard
        v-editable="blok"
        class="service-cards__card"
        :class="`service-cards__card--${tone}`"
        :title="blok.title"
        :text="blok.text"
        :meta="blok.meta"
        :href="href"
        :link-label="blok.link_label"
    >
        <template
            v-if="blok.icon"
            #icon
        >
            <Icon :name="blok.icon" />
        </template>
    </KServiceCard>
</template>

<script setup>
import { KServiceCard } from '@vemedia/karibu'
import { storyblokLinkHref } from '~~/shared/storyblok-link'

const { blok, tone } = defineProps({
    blok: {
        type: Object,
        required: true,
    },
    tone: {
        type: String,
        default: 'accent',
    },
})

const href = computed(() => storyblokLinkHref(blok.link) || undefined)
</script>
